import { Settings } from "@core/shared/types";
import { atom } from "@mongez/react-atom";

// Default settings to use when API fails
export const getDefaultSettings = (): Settings => ({
  communityGroups: {
    disableImageContextMenu: false,
  },
  general: {
    appName: "Mentor Me",
    description: "Your learning platform",
    primaryColor: "#3B82F6",
    about: "Empowering education through technology",
    brief: "Learn and grow with our platform",
    url: "",
    paymentMethods: [],
    logo: null as any,
    footerLogo: null as any,
    favIcon: null as any,
  },
  contact: {
    email: "support@mentorme.com",
    phoneNumber: "+1234567890",
    address: "Your Address",
    workingDays: "Monday - Friday",
    whatsappNumber: "+1234567890",
    location: {
      lat: 0,
      lng: 0,
      address: "Your Location",
    },
  },
  social: {},
  integrations: {
    googleMap: "",
    googleAnalytics: "",
    googleTagManager: "",
    facebookAppId: "",
    facebookPixel: "",
  },
});

export const settingsAtom = atom<Settings>({
  key: "settings",
  default: getDefaultSettings(),
});
